import React from 'react';
import { motion } from 'framer-motion';
import { LibraryIcon, LayersIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/dJxML6sdS9Vd1dGLitULgq/ChatGPT_Image_6_sept_2026,_19_08_55.png';
const facts = [{
  icon: LibraryIcon,
  label: '120 Ready-to-Teach Classes'
}, {
  icon: LayersIcon,
  label: '6 Professional Volumes'
}, {
  icon: DownloadIcon,
  label: 'Instant Digital Access'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-62" data-mp="xa4ibf8y0fgn">
      <div className="relative mx-auto w-full max-w-content px-5 pb-8 pt-5 sm:px-8 sm:pb-12 sm:pt-8" data-id="element-63" data-mp="sbb0xbqjc4b7">
        <p className="text-center font-serif text-[0.7rem] uppercase tracking-label text-forest" data-id="element-64" data-mp="nc858hwg3afw">
          Yoga Teacher System<sup className="text-[0.55em]" data-id="element-65" data-mp="3d21ty23jwspu">™</sup>
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-3 max-w-3xl text-center" data-id="element-66" data-mp="3czfoc8080na9">
          <p className="text-[0.6rem] font-semibold uppercase tracking-label text-gold sm:text-xs" data-id="element-67" data-mp="3o858h3cjnn0v">
            

          </p>

          <h1 className="mt-3 font-serif text-[1.85rem] font-semibold uppercase leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-[3.4rem]" data-id="element-68" data-mp="399jq3lb5st9t">
            The complete teaching system
            <span className="block text-forest" data-id="element-69" data-mp="30h9b7qpbjzm8">for yoga teachers</span>
          </h1>

          <p className="mx-auto mt-3 max-w-xl text-[0.9rem] leading-snug text-muted sm:text-base" data-id="element-70" data-mp="358zu4l2bnvp9">
            Save hours of planning, teach better classes, and walk into every session prepared —
            without building every class from scratch.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} src={MOCKUP} alt="Yoga Teacher System — the six volume covers of the class library" className="mx-auto mt-2 w-full max-w-4xl sm:mt-4" width={1536} height={1024} data-id="element-71" data-mp="2hinc2hdd4iky" />

        <ul className="grid grid-cols-3 gap-2 sm:mx-auto sm:max-w-2xl sm:gap-3" data-id="element-72" data-mp="id9vei3jojvx">
          {facts.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex flex-col items-center gap-1.5 rounded-2xl border border-sandDark/70 bg-ivory/70 px-2 py-3 text-center" data-id="element-73" data-mp="deyjm1tovzb2">
              <Icon className="h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-74" data-mp="162ccnou9oapw" />
              <span className="text-[0.58rem] font-semibold uppercase leading-tight tracking-label text-ink sm:text-[0.68rem]" data-id="element-75" data-mp="111ogypv3f5pc">
                {label}
              </span>
            </li>)}
        </ul>

        <p className="mt-4 text-center font-serif text-sm uppercase tracking-label text-forest sm:text-lg" data-id="element-76" data-mp="3lui8konbuvkb">
          Open <span className="text-gold" data-id="element-77" data-mp="3hq27r1skmeby">•</span> Choose <span className="text-gold" data-id="element-78" data-mp="1x9umefegzlpj">•</span> Teach
        </p>

        <div className="mt-4" data-id="element-79" data-mp="1x786nshfdzw8">
          <CtaButton label="Get instant access" microcopy="One-Time Purchase • Instant Digital Access" data-id="element-80" data-mp="21aeirgr7ylam" />
        </div>
      </div>
    </header>;
}